export const Types = {
  SAVE_CAMPAIGN: 'SAVE_CAMPAIGN',
  SAVE_HISTORY_REWARD : 'SAVE_HISTORY_REWARD',
  SAVE_CONFIGURE_PROGRAM : 'SAVE_CONFIGURE_PROGRAM',
  SAVE_LIST_TEMPLATE_EVOUCHER : 'SAVE_LIST_TEMPLATE_EVOUCHER',
  SAVE_CONFIG_EVOUCHER_PROGRAM : 'SAVE_CONFIG_EVOUCHER_PROGRAM'
}
